module.exports = __webpack_public_path__ + "img/fromages.7c405c44.svg";